const features = [
  {
    icon: 'ri-shield-keyhole-line',
    title: 'Military-Grade Encryption',
    desc: 'AES-256 encryption protects all data in transit, ensuring absolute privacy from third parties and surveillance.',
    color: 'text-emerald-500',
    bg: 'bg-emerald-500/10',
  },
  {
    icon: 'ri-speed-line',
    title: 'Lightning Performance',
    desc: 'Lightweight architecture ensures our apps run smoothly without impacting battery life or system resources.',
    color: 'text-teal-500',
    bg: 'bg-teal-500/10',
  },
  {
    icon: 'ri-smartphone-line',
    title: 'iOS Native Design',
    desc: 'Built specifically for iOS using native frameworks, delivering smooth animations and pixel-perfect UI.',
    color: 'text-emerald-400',
    bg: 'bg-emerald-400/10',
  },
  {
    icon: 'ri-eye-off-line',
    title: 'Strict No-Logs Policy',
    desc: 'We collect zero personal data. Your browsing habits and device usage remain entirely private.',
    color: 'text-teal-400',
    bg: 'bg-teal-400/10',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Automatic Updates',
    desc: 'Continuous improvements and security patches are delivered seamlessly through the App Store.',
    color: 'text-emerald-500',
    bg: 'bg-emerald-500/10',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Dedicated Support',
    desc: 'Our expert team is on hand to resolve issues quickly and ensure the best possible user experience.',
    color: 'text-teal-500',
    bg: 'bg-teal-500/10',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="bg-[#f8f9fa] py-28 px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-emerald-100 text-emerald-700 text-xs font-semibold tracking-widest uppercase rounded-full px-4 py-1.5 mb-5">
            Features
          </div>
          <h2 className="text-4xl xl:text-5xl font-extrabold text-[#0c0e12] mb-4">
            Why Choose IDEA D.O.O.
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto leading-relaxed">
            Our products are built around a set of core principles that put user security,
            performance, and experience above all else.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feat) => (
            <div key={feat.title} className="bg-white rounded-xl p-8 border border-gray-100 group hover:border-emerald-200 transition-all duration-300">
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${feat.bg} mb-5 transition-transform duration-300 group-hover:scale-110`}>
                <i className={`${feat.icon} text-xl ${feat.color}`} />
              </div>
              <h4 className="font-bold text-[#0c0e12] text-lg mb-3">{feat.title}</h4>
              <p className="text-gray-500 text-sm leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>

        {/* CTA Banner */}
        <div className="mt-16 rounded-2xl overflow-hidden relative">
          <img
            src="https://public.readdy.ai/ai/img_res/1aaa6434cd482e84bf5ca6c063f823c1.jpg"
            alt="features banner background"
            className="w-full h-[200px] object-cover object-top"
          />
          <div className="absolute inset-0 bg-black/55 flex flex-col md:flex-row items-center justify-between px-12 gap-4">
            <div>
              <h3 className="text-white text-2xl font-extrabold">Secure. Fast. Reliable.</h3>
              <p className="text-white/60 text-sm mt-1">Trusted by hundreds of thousands of iOS users worldwide.</p>
            </div>
            <div className="flex items-center gap-6">
              {[
                { icon: 'ri-apple-line', label: 'iOS Platform' },
                { icon: 'ri-global-line', label: 'Global Coverage' },
                { icon: 'ri-award-line', label: 'Top Rated' },
              ].map((item) => (
                <div key={item.label} className="flex flex-col items-center gap-1.5">
                  <div className="w-10 h-10 flex items-center justify-center bg-emerald-500/20 rounded-full">
                    <i className={`${item.icon} text-emerald-400 text-lg`} />
                  </div>
                  <span className="text-white/70 text-xs whitespace-nowrap">{item.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
